const messages = {
    title: 'Турнир Городов',
    'UnderConstructionPage.note': 'Загрузка работ в систему электронной проверки будет доступна позднее.',
    'ExternalPageTemplate.TofT': 'Турнир Городов',

    'SignUpPage.You need to register': 'Зарегистрируйтесь, чтобы начать загружать работы участников.',
    'SignUpPage.town': 'Город',
    'SignUpPage.name': 'Имя',
    'SignUpPage.email': 'Email',
    'SignUpPage.register': 'Зарегистрироваться',
    'SignUpPage.Already registered?': 'Уже зарегистрировались?',
    'SignUpPage.Sign in': 'Войти',
    'SignUpPage.Cannot register': 'Не удаётся зарегистрировать пользователя',
    'SignUpPage.Fill in town name': 'Введите название города',
    'SignUpPage.Fill in name': 'Введите имя',
    'SignUpPage.Wrong email': 'Некорректный email',
    'SignUpPage.Email sent':
        'Вы успешно зарегистрированы. Пожалуйста, перейдите по ссылке, отправленной на {email}, чтобы подтвердить свой адрес.',

    'SignInPage.Sign In to the system': 'Вход в систему электронной проверки',
    'SignInPage.No account?': 'Нет аккаунта?',
    'SignUpPage.Sign up': 'Зарегистрироваться',
    'SignInPage.email': 'Email',
    'SignInPage.password': 'Пароль',
    'SignInPage.sign in': 'Войти',
    'SignInPage.No such user': 'Пользователь не существует или указан неправильный пароль',
    'SignUpPage.Forgot password': 'Забыли пароль?',

    'CreatePasswordPage.create new password': 'Создайте новый пароль',
    'CreatePasswordPage.new password': 'Новый пароль',
    'CreatePasswordPage.repeat password': 'Повторите',
    'CreatePasswordPage.save': 'Сохранить',
    'CreatePasswordPage.fill in password': 'Укажите пароль',
    'CreatePasswordPage.passwords must be the same': 'Пароли должны совпадать',
    'CreatePasswordPage.Cannot set password': 'Не удалось установить новый пароль',
    'CreatePasswordPage.Success': 'Пароль успешно установлен.',
    'CreatePasswordPage.sign in': 'Войти',

    'ResetPasswordPage.fill in email': 'Введите email',
    'ResetPasswordPage.Wrong email': 'Некорректный email',
    'ResetPasswordPage.Cannot reset password': 'Не удалось сбросить пароль',
    'ResetPasswordPage.Email sent':
        'Пожалуйста, перейдите по ссылке, отправленной на {email}, чтобы установить новый пароль.',
    'ResetPasswordPage.reset password': 'Восстановление пароля',
    'ResetPasswordPage.Instructions will be sent':
        'Инструкции по созданию нового пароля будут отправлены на укзанный email',
    'ResetPasswordPage.email': 'Email',
    'ResetPasswordPage.send': 'Отправить',

    'OrgHomePage.RegList': 'Реглист',
    'OrgHomePage.Upload': 'Загрузить работы',
    'OrgHomePage.Participants list': 'Список участников',
    'OrgHomePage.Exit': 'Выйти',

    'OrgHomePage.Fill in RegList': 'Заполнить реглист',
    'OrgHomePage.Upload papers': 'Загрузить работы',
    'OrgHomePage.Fill in details': 'Заполнить данные участников',
    'OrgHomePage.TofT': 'Турнир Городов',
    'OrgHomePage.Send for marking': 'Отправить на проверку',

    'OrgHomePage.send success': 'Работы отправлены на проверку.',

    'OrgHomePage.upload success title': 'Работы участников успешно загружены.',
    'OrgHomePage.upload success note': 'Чтобы отправить их на проверку, нажмите на кнопку внизу страницы. ',
    'OrgHomePage.upload success note 2':
        'После этого загрузка новых работ и редактирование реглиста и информации об участниках будут недоступны.',
    'OrgHomePage.upload success': 'До отправки вы можете {regList} или {viewParticipants}.',
    'OrgHomePage.regList': 'отредактировать реглист',
    'OrgHomePage.viewParticipants': 'загрузить новые работы',

    'OrgHomePage.fall': 'Осень',
    'OrgHomePage.spring': 'Весна',

    'OrgHomePage.wait': 'Загрузка работ будет доступна позже.',

    'AdminHomePage.RegListsList': 'Реглисты',
    'AdminHomePage.TownsList': 'Города',
    'AdminHomePage.BatchesList': 'Пачки',
    'AdminHomePage.New Town': 'Добавить город',
    'AdminHomePage.Exit': 'Выйти',
    'AdminHomePage.TofT': 'Турнир Городов',

    'RegListsList.No reglists': 'Реглисты ещё не созданы.',
    'RegListsList.townName': 'Город',
    'RegListsList.email': 'Email',
    'RegListsList.orgHeadName': 'Председатель оргкомитета',
    'RegListsList.participantDraftsCount': 'Количество участников',
    'RegListsList.registration': 'Регистрация',
    'RegListsList.register': 'Зарегистрировать',
    'RegListsList.town': 'Город',

    'RegListAdmin.No such reglist': 'Реглист не найден',
    'RegListAdmin.town info': 'Данные о городе',
    'RegListAdmin.participants list': 'Список участников',
    'RegListAdmin.no participants': 'Организатор пока не загрузил ни одной работы',

    'RegList.town info': 'Данные о городе',
    'RegList.contact info': 'Контакты',
    'RegList.tournament info': 'Данные о проведении Турнира',
    'RegList.save': 'Сохранить',
    'RegList.required': 'Заполните это поле',
    'RegList.global error': 'Ошибка. Не удалось сохранить регистрационный лист.',

    'RegList.townName': 'Город',
    'RegList.population': 'Население (с некоторыми пригородами, если Турнир проводится и для них)',
    'RegList.lastGrade': 'Последний класс в школах',
    'RegList.orgHeadName': 'ФИО Председателя местного оргкомитета',
    'RegList.orgHeadPosition': 'Место работы и должность Председателя местного оргкомитета',
    'RegList.juryHeadName': 'ФИО Председателя местного жюри',
    'RegList.juryHeadPosition': 'Место работы и должность Председателя местного жюри',
    'RegList.address': 'Почтовый адрес, по которому лучше всего высылать проверенные работы и дипломы',
    'RegList.addressee': 'ФИО адресата',
    'RegList.email': 'Email',
    'RegList.phone': 'Телефоны для горячей связи',
    'RegList.town pays': 'Город платит за участие в Турнире по договору',
    'RegList.town does not pay': 'Не платит и просит обслуживать бесплатно',
    'RegList.paymentData': 'Годовой взнос и срок платежа, проведённого (номер платёжного поручения) или будущего',
    'RegList.invitations': 'Приглашение на Турнир: широкое оповещение или укажите принцип отбора приглашаемых',
    'RegList.pDate': 'Фактическая дата базового варианта',
    'RegList.mDate': 'Фактическая дата сложного варианта',
    'RegList.tDate': 'Фактическая дата базового варианта',
    'RegList.vDate': 'Фактическая дата сложного варианта',
    'RegList.pPapersNumber': 'Число писавших базовый вариант',
    'RegList.mPapersNumber': 'Число писавших сложный вариант',
    'RegList.tPapersNumber': 'Число писавших базовый вариант',
    'RegList.vPapersNumber': 'Число писавших сложный вариант',
    'RegList.participantsNumber': 'Число участников (писавший оба варианта считается один раз)',
    'RegList.sentPPapersNumber': 'Отправленных в Москву работ базового варианта',
    'RegList.sentMPapersNumber': 'Отправленных в Москву работ сложного варианта',
    'RegList.sentTPapersNumber': 'Отправленных в Москву работ базового варианта',
    'RegList.sentVPapersNumber': 'Отправленных в Москву работ сложного варианта',
    'RegList.sentParticipantsNumber':
        'Число участников, чьи работы были отправлены (писавший оба варианта считается один раз)',
    'RegList.rulesAreFollowed': 'Правила соблюдены',
    'RegList.ruleBreakersList': 'Список присланных работ возможных нарушителей',
    'RegList.comments': 'Замечания',

    'EnterData.save': 'Сохранить',
    'EnterData.name': 'Имя',
    'EnterData.email': 'Email',
    'EnterData.grade': 'Класс',
    'EnterData.school': 'Школа',
    'EnterData.gender': 'Пол',

    'EnterData.round.p': 'Базовый',
    'EnterData.round.m': 'Сложный',
    'EnterData.round.t': 'Базовый',
    'EnterData.round.v': 'Сложный',
    'EnterData.required': 'Укажите',
    'EnterData.invalid email': 'Некорректный email',
    'EnterData.global error': 'Ошибка. Не удалось загрузить файлы.',
    'EnterData.gender.m': 'м',
    'EnterData.gender.f': 'ж',

    'ParticipantList.name': 'Имя',
    'ParticipantList.grade': 'Класс',
    'ParticipantList.gender': 'Пол',
    'ParticipantList.school': 'Школа',
    'ParticipantList.email': 'Email',
    'ParticipantList.papers': 'Работы',
    'ParticipantList.round.p': 'базовый',
    'ParticipantList.round.m': 'сложный',
    'ParticipantList.round.t': 'базовый',
    'ParticipantList.round.v': 'сложный',
    'ParticipantList.no participants': 'Вы ещё не загрузили ни одной работы. {uploadLink}',
    'ParticipantList.upload': 'Загрузить',
    'ParticipantList.delete': 'Удалить',
    'ParticipantList.merge': 'Объединить',

    'UploadPapers.Drop here': 'Перетяните файлы сюда или нажмите, чтобы выбрать файлы для загрузки.',
    'UploadPapers.File types': 'Каждая работа должна быть в отдельном pdf или zip файле.',
    'UploadPapers.next': 'Далее',
    'UploadPapers.added files': 'Добавленные файлы',
    'UploadPapers.invalid files': 'Файлы, которые не удалось добавить',
    'UploadPapers.invalid files subtitle': 'Переименуйте их по примеру Москва_Иванов_Иван_М_Б_9.pdf и попробуйте снова',

    'RegisterTown.name.ru': 'Город',
    'RegisterTown.name.en': 'Английское',
    'RegisterTown.name.local': 'Местное название',
    'RegisterTown.name.genitive': 'Название в родительном падеже',
    'RegisterTown.comment': 'Комментарий',
    'RegisterTown.region': 'Регион',
    'RegisterTown.language': 'Язык',
    'RegisterTown.population': 'Население',
    'RegisterTown.contacts.person': 'Контактное лицо',
    'RegisterTown.contacts.email': 'Email',
    'RegisterTown.contacts.phone': 'Телефон',
    'RegisterTown.contacts.address': 'Адрес для бандеролей',
    'RegisterTown.organizingCommitteePresident': 'Председатель оргкомитета',
    'RegisterTown.juryPresident': 'Председатель жюри',
    'RegisterTown.grade changes at summer': 'Смена класса летом',
    'RegisterTown.grade changes at winter': 'Смена класса зимой',
    'RegisterTown.diploma info': 'Данные для дипломов',
    'RegisterTown.grade settings': 'Настройки классов',
    'RegisterTown.defaultGradeSettings': 'Использовать настройки турнира',
    'RegisterTown.firstSeniorGrade': 'Первый класс, пишущий старший вариант',
    'RegisterTown.last grade': 'Последний класс в школах (по реглисту)',

    'RegisterTown.Register Town': 'Зарегистрировать город',
    'RegisterTown.Register Participants': 'Зарегистрировать участников',
    'RegisterTown.success': 'Город успешно зарегистрирован',

    'CreateTown.Register Town': 'Зарегистрировать город',
    'CreateTown.Upload papers': 'Загрузить работы',
    'CreateTown.Register Participants': 'Зарегистрировать участников',
    'CreateTown.success': 'Город успешно зарегистрирован',

    'MergeDialog.title': 'Объединить участников',
    'MergeDialog.merge': 'Объединить',
    'MergeDialog.cancel': 'Отмена',

    'TownsList.No towns': 'Ни одного города не зарегистрировано',

    'Town.No such town': 'Город не найден',
    'Town.no participants': 'Ни одного участника не зарегистрировано',
    'Town.deduplicate': 'Убрать дубли',
    'Town.upload papers': 'Загрузить работы',
    'Town.success upload': 'Работы загружены.',
    'Town.to participants': 'К списку участников',
    'Town.report': 'Отчёт',

    'TownsList.participantCount': 'Участники',
    'TownsList.p.junior': 'Базовый младший',
    'TownsList.p.senior': 'Базовый старший',
    'TownsList.m.junior': 'Сложный младший',
    'TownsList.m.senior': 'Сложный старший',

    'TownsList.t.junior': 'Базовый младший',
    'TownsList.t.senior': 'Базовый старший',
    'TownsList.v.junior': 'Сложный младший',
    'TownsList.v.senior': 'Сложный старший',

    'Paper.save': 'Сохранить',

    'Report.TofT': 'Международный Математический Турнир Городов',

    'Report.round.p': 'осенний базовый',
    'Report.round.m': 'осенний сложный',
    'Report.round.t': 'весенний базовый',
    'Report.round.v': 'весенний сложный',
    'Report.level.junior': 'младший',
    'Report.level.senior': 'старший',

    'Report.participant.nominal': 'участник',
    'Report.participant.genitive': 'участника',
    'Report.participant.plural': 'участников',

    'Report.paper.nominal': 'работа',
    'Report.paper.genitive': 'работы',
    'Report.paper.plural': 'работ',

    'Report.diploma.nominal': 'диплом',
    'Report.diploma.genitive': 'диплома',
    'Report.diploma.plural': 'дипломов',

    'Report.point.nominal': 'балл',
    'Report.point.genitive': 'балла',
    'Report.point.plural': 'баллов',

    'Report.grade': 'класс',
    'Report.marks': 'оценки',
    'Report.points': 'баллы',
    'Report.result': 'результат',
    'Report.total result': 'Итоговый результат',
    'Report.awarded with diploma': 'Диплом победителя Турнира Городов',

    'Report.PresidentOfAll': 'Председатель местных Оргкомитета и Жюри',
    'Report.PresidentOfOrg': 'Председатель местного Оргкомитета',
    'Report.PresidentOfJury': 'Председатель местного Жюри',

    'Report.correction coeffs': 'Поправочные коэффиценты',
    'Report.junior': 'младший вариант',
    'Report.senior': 'старший вариант',

    'Report.threshold': 'Дипломом победителя Турнира награждаются участники, набравшие {threshold} и более баллов.',

    'PaperForm.round': 'Тур',
    'PaperForm.level': 'Вариант',

    'RegisterParticipants.add': 'Добавить участника',

    'Help.Drag files':
        'Выберите или перетяните файлы. Если они названы в соответствии с требованиями — данные участников разпознаются автоматически.',
    'Help.Fill in': 'Заполните остальные данные и нажмите кнопку "Сохранить".',
    'Help.Manual': 'Если названия файлов не соответствуют схеме, вы можете заполнить все данные участников вручную.',
    'Help.close': 'Закрыть',
};

export default messages;



// WEBPACK FOOTER //
// ./src/translations/ru.js